import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';

export const StyledCard = styled.div`
  background-color: ${COLORS.GRAY_LIGHT};
  border: 1px solid ${COLORS.BORDER};
  flex-direction: column;
  display: flex;
  padding: 1rem;
  gap: 0.5rem;
  border-bottom: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  border-right: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  border-top: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  width: 100%;

  @media screen and ${DEVICES.LAPTOP_S} {
    min-width: 18rem;
  }
`;

export const StyledInfoWrapper = styled.div`
  flex-direction: column;
  display: flex;
  gap: 0.5rem;
  height: 100%;
`;

export const StyledCardRow = styled.div`
  display: flex;
  width: 100%;
  gap: 0.75rem;
  align-items: center;

  svg {
    overflow: visible;
    path {
      fill: ${pickThemeColor('LIGHT_PURPLE')};
      stroke: ${pickThemeColor('LIGHT_PURPLE')};
    }
  }
`;

export const StyledCardComment = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block; // или block — в зависимости от контекста
  ${pickThemeFontStyles('14', '20')};
`;

export const StyledTooltipContent = styled.div`
  &&& {
    padding: 1rem;
    color: ${pickThemeColor('WHITE')};
  }
`;

export const StyledTitleRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 0.27rem;
  align-items: center;
`;

export const StyledHighlightedRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  border-radius: 0.25rem;
  padding: 0.5rem;
`;

export const StyledCardLabel = styled.span`
  color: ${COLORS.GREY_DARK};
  ${pickThemeFontStyles('14', '20', 'SEMI_BOLD')};
`;

export const StyledCardValue = styled.span`
  color: ${pickThemeColor('GREY_DARK')};
  ${pickThemeFontStyles('14', '20')};
  word-break: break-word;
`;

export const StyledPeopleCount = styled.span`
  color: ${pickThemeColor('GREY_DARK')};
  ${pickThemeFontStyles('14', '20')};
  white-space: nowrap;
`;

export const StyledBidAlertBadge = styled.span`
  padding: 0.125rem 0.5rem;
  border-radius: 1rem;
  background-color: ${pickThemeColor('PEACH_LIGHT')};
  color: ${pickThemeColor('ORANGE_PRIMARY')};
  ${pickThemeFontStyles('12', '18', 'SEMI_NORMAL')};
  white-space: nowrap;
`;

export const StyledCardTitle = styled.span`
  color: ${pickThemeColor('DARK_PURPLE')};
  ${pickThemeFontStyles('18', '26', 'BOLD')};
`;
